<template>
  <PeModal
    v-model="showDialog"
    :hideCancelButton="hideCancelButton"
    :cancelButtonText="cancelButtonText"
    :confirmButtonText="confirmButtonText"
    width="624px"
    trap-focus
    close-on-esc
    confirm-on-enter
    @on-confirm="onConfirm"
    @on-cancel="onCancel"
  >
    <div class="flex min-h-[220px] items-center">
      <div v-if="!hideImage" class="text-6xl text-amber-500">
        <UiIcon icon="alert-triangle" strokeWidth="1.0" />
      </div>
      <div class="grow self-center px-6 overflow-hidden break-words dark:text-neutral-300 text-center">
        <div v-if="title" class="text-3xl pt-4">{{ title }}</div>
        <div class="max-h-[500px] overflow-y-auto py-4">
          <div v-if="message" class="text-[15px] leading-[22px]" v-html="message" />
          <slot />
        </div>
      </div>
    </div>
  </PeModal>
</template>

<script setup lang="ts">
import { ref, computed, onMounted } from 'vue'

import PeModal from './PeModal.vue'
import UiIcon from './ui/icon.vue'

const props = defineProps<{
  modelValue?: boolean
  auto?: boolean // Se deve ser aberto automaticamente
  title?: string
  message?: string
  show?: boolean
  hideImage?: boolean
  hideCancelButton?: boolean
  cancelButtonText?: string
  confirmButtonText?: string
  alt?: boolean
}>()

const emit = defineEmits(['onConfirm', 'onCancel', 'update:modelValue'])

const internalValue = ref(false)

const showDialog = computed({
  get: () => (props.auto && internalValue.value) || props.modelValue || false,
  set(newValue) {
    if (!props.auto) emit('update:modelValue', newValue)
    else internalValue.value = newValue
  }
})

const onConfirm = () => {
  // if (typeof props.complete === 'function' && props.complete)
  //   props.complete()

  emit('onConfirm')
}

const onCancel = () => {
  emit('onCancel')
}

onMounted(() => {
  internalValue.value = props.auto || false
})

defineExpose({
  message: props.message,
  onConfirm,
  close
})
</script>

<style scoped></style>
